<template>
  <section>
    <form action v-on:submit.prevent="">
      <div class="modal-card" style="height: 1000px; width: 100%">
        <header class="modal-card-head">
          <p>Buscar</p>
        </header>
        <section class="modal-card-body">
          <b-field>
            <b-input
              v-model="text"
              placeholder="Ingresar lo que quiere buscar..."
              type="search"
              icon="search"
            >
            </b-input>
            <p class="control">
              <button class="button is-primary" @click="search">Buscar</button>
            </p>
          </b-field>
          <b-table
            type="is-primary"
            :data.sync="listDocument.data"
            :loading="loading"
            :is-fullwidth="true"
            detailed
            narrowed
            paginated
            backend-pagination
            :total="listDocument.total"
            :per-page="listDocument.per_page"
            @page-change="onPageChange"
          >
            <template slot-scope="props">
              <b-table-column field="number" label="N° Documento" searchable>{{
                props.row.number
              }}</b-table-column>
              <b-table-column field="date_document" label="Fecha" searchable>
                <span class="tag is-success">
                  {{ props.row.date_document }}
                </span>
              </b-table-column>
              <b-table-column
                field="document_type.name"
                label="Tipo de Documento"
                searchable
                >{{ props.row.document_type.name }}</b-table-column
              >
              <b-table-column field="cellar.name" label="Bodega" searchable>{{
                props.row.cellar.name
              }}</b-table-column>
              <b-table-column
                field="remitent.name"
                label="Remitente"
                searchable
                >{{
                  props.row.remitent ? props.row.remitent.name : "Sin Remitente"
                }}</b-table-column
              >

              <b-table-column label="Acciones" width="200px">
                <div class="buttons">
                  <!-- <b-button
                    type="is-primary is-small"
                    icon-left="search"
                    @click="openViewPdf(props.row.id)"
                  ></b-button> -->
                  <a :href="props.row.file" target="_blank">
                    <b-button
                      type="is-primary is-small"
                      icon-left="download"
                    ></b-button>
                  </a>
                </div>
              </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <article class="media">
                <div class="media-content">
                  <div class="content">
                    <p><b>Descripción:</b> {{ props.row.description }}</p>
                  </div>
                </div>
              </article>
            </template>
          </b-table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="$parent.close()">Cerrar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>
import { DocumentService } from "../../services/models/document";
// import ViewPdf from "../../../components/administrative/document/ViewPdf";

export default {
  data() {
    return {
      text: "",
      listDocument: [],
      loading: false,
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5,
    };
  },
  methods: {
    onPageChange(page) {
      this.search(page);
    },
    async search(page) {
      this.loading = true;
      const { data: document } = await DocumentService.getFindByDocumentAll(
        this.text,
        page
      );
      this.listDocument = document;
      console.log(this.listDocument);
      this.loading = false;
    },
  },
};
</script>